module.exports = __webpack_public_path__ + "static/postgresql-cc4f248e46b9043180e4fefbe4fde307.png";